import React from 'react';
export default function StackedIcon({
  children
}) {
  return /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'grid',
      gridTemplate: '1fr / 1fr',
      placeItems: 'center'
    }
  }, children);
}